import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ReadersTable } from '@/components/ReadersTable/ReadersTable';
import { READERS_TABLE_QUERY_KEY } from '@/lib/readersCatalogQueryCache';
import './ReadersPage.css';

export interface ReadersPageProps {
  onOpenPersonManage?: (personId: string) => void;
}

export function ReadersPage({ onOpenPersonManage }: ReadersPageProps) {
  const queryClient = useQueryClient();

  useEffect(() => {
    void queryClient.invalidateQueries({ queryKey: READERS_TABLE_QUERY_KEY });
    void queryClient.invalidateQueries({ queryKey: ['readersTableSummaries'] });
  }, [queryClient]);

  return (
    <div className="readers-page">
      <div className="readers-page__table-wrap">
        <ReadersTable onOpenPersonManage={onOpenPersonManage} />
      </div>
    </div>
  );
}
